import * as actionTypes from './actionTypes';
import { TAB_PATIENT } from 'services/constants';
import { updateStateByObj } from '../../services/payments';

const initialState = {
  activeTab: TAB_PATIENT,
  patient: {},
  invoice: {},
  timeline: [],
  activeAppointment: {}
};

export default (state = { ...initialState }, action) => {
  switch (action.type) {
    // Appointment
    case actionTypes.CLEAR_APPOINTMENT:
      return initialState;
    case actionTypes.UPDATE_APPOINTMENT:
      return updateStateByObj(state, action.payload.dataObj);

    // Active appointment
    case actionTypes.ADD_ACTIVE_APPOINTMENT:
      return { ...state, activeAppointment: action.payload };
    case actionTypes.REMOVE_ACTIVE_APPOINTMENT:
      return { ...state, activeAppointment: {} };
    case actionTypes.LOAD_APPOINTMENT_BY_ID_SUCCESS:
      return { ...state, activeAppointment: action.payload };
    case actionTypes.LOAD_APPOINTMENT_BY_ID_ERROR:
      return { ...state, activeAppointment: {} };
    case actionTypes.UPDATE_ACTIVE_APPOINTMENT: {
      return {
        ...state,
        activeAppointment: updateStateByObj(state.activeAppointment, action.payload.dataObj)
      };
    }

    // Invoice
    case actionTypes.CLEAR_INVOICE: {
      const activeAppointment = state.activeAppointment;
      delete activeAppointment.invoice;
      return { ...state, invoice: {}, activeAppointment };
    }
    case actionTypes.LOAD_INVOICE_SUCCESS:
      return { ...state, invoice: action.payload };
    case actionTypes.LOAD_INVOICE_ERROR:
      return { ...state, invoice: {} };

    // Patient
    case actionTypes.CLEAR_PATIENT:
      return { ...state, patient: {} };
    case actionTypes.LOAD_PATIENT_SUCCESS:
      return { ...state, patient: action.payload };
    case actionTypes.LOAD_PATIENT_ERROR:
      return { ...state, patient: {} };

    // Tabs
    case actionTypes.CHANGE_ACTIVE_TAB:
      return { ...state, activeTab: action.payload };

    // Payments
    case actionTypes.CONFIRM_PAYMENT_SUCCESS:
      return { ...state };
    case actionTypes.CONFIRM_PAYMENT_ERROR:
      return { ...state };

    // Workflow
    case actionTypes.TRIGGER_WORKFLOW_SUCCESS:
      return { ...state };
    case actionTypes.TRIGGER_WORKFLOW_ERROR:
      return { ...state };
    case actionTypes.LOAD_WORKFLOW_TIMELINE_SUCCESS:
      return { ...state, timeline: action.payload };
    case actionTypes.LOAD_WORKFLOW_TIMELINE_ERROR:
      return { ...state, timeline: [] };
    case actionTypes.CLEAR_TIMELINE:
      return { ...state, timeline: [] };

    default:
      return state;
  }
};
